'use strict';

import { isElement, forEach } from 'lodash';
import Breakpoint from '../01-helpers/breakpoint-util';
import { subscribe } from '../01-helpers/event-manager';
import { BREAKPOINT_CHANGE } from '../02-const/event-names';
import getHandicapHandout from '../03-api/handicap/gethandicaphandout';


const
	moduleName = 'handicap-handout',
	selectors = {
		base: `.js-${moduleName}`,
		target: `.js-${moduleName}__target`
	};

export default class HandicapHandout {

	constructor(baseElement) {
		if (!isElement(baseElement)) {
			return false;
		}
		
		this.baseElement = baseElement;
		this.target = baseElement.querySelector(selectors.target);

		this._bindEvents();

		this._loadContent();
	}

	/**
	 * Load the content for the modal 
	 **/
	_loadContent() {
		const loadingblock = `
			<div class="c-loader__container">
				<span class="c-loader"></span> Bezig met laden ...
			</div>
		`;

		this.target.innerHTML = loadingblock;

		const data = {
			size: Breakpoint.isDesk() ? 'desktop' : 'mobile'
		}

		getHandicapHandout(data)
			.done(result => {
				this.target.innerHTML = result.Data;
			})
			.fail(error => {
				//@TODO: console.error(this.translations[translationsKey.HandicapHandoutError]);
				console.error(error);
			});
	}

	_breakpointChanged() {
		console.log('breakpointChanged');
		this._loadContent();
	}


	_bindEvents() {
		console.log('event: ', BREAKPOINT_CHANGE);
		subscribe(BREAKPOINT_CHANGE, this._breakpointChanged.bind(this));
	}
}